export default __webpack_public_path__ + "static/media/Aura-Egg__07.026e9028.png";